export default "__VITE_ASSET__c5bi7Z9G__"